import { twClassMerge } from '@healthhub/react-ui';
import type { ModalProps } from 'antd';
import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';


import { ConfirmModal } from '../ConfirmModal';

export interface ExitConfirmationModalProps extends Omit<
  ModalProps,
  'centered' | 'closable' | 'footer' | 'onCancel' | 'onOk'
> {
  className?: string;
  description?: string;
  onCancelClick: () => void;
  onOkClick: () => void;
  open: boolean;
  title?: string;
}

const ExitConfirmationModal: React.FC<ExitConfirmationModalProps> = ({
  className,
  description,
  onCancelClick,
  onOkClick,
  open,
  title,
}) => {
  const { t } = useTranslation();

  return (
    <ConfirmModal
      cancelText={t('button.cancel')}
      className={twClassMerge('[&_.ant-modal-body]:p-4 max-w-96', className)}
      descriptionTop={description}
      okText={t('button.ok').toUpperCase()}
      onCancel={onCancelClick}
      onOk={onOkClick}
      open={open}
      title={title}
    />
  );
};

export default memo(ExitConfirmationModal);
